import React from 'react'

import PageSection from 'components/common/PageSection'
import { AgentDetails } from 'components/configurations/agents/AgentDetails'
import { useAgentDetailsDrawerContext } from 'components/configurations/contexts/AgentDetailsDrawerContext'
import { useGetClientsByIdentifier } from 'queries/clients/use-get-clients-by-identifier'
import { useGetFailureFlagsApp } from 'queries/failure-flags/use-get-failure-flags-app'
import { AgentType } from 'types/api/agents/agents'
import { messageFromResponseError } from 'utils/strings'

export const AgentDetailsDrawerContent: React.FC<{
  isOpen: boolean
}> = () => {
  const { activeAgent } = useAgentDetailsDrawerContext()

  const queryGetAgentDetails =
    activeAgent?.type === AgentType.INFRASTRUCTURE
      ? useGetClientsByIdentifier
      : useGetFailureFlagsApp

  const {
    data: agentDetails,
    isLoading: isLoadingAgentDetails,
    isError: isErrorAgentDetails,
    error: errorAgentDetails
  } = queryGetAgentDetails(activeAgent?.id, {
    enabled: Boolean(activeAgent)
  })

  return (
    <PageSection
      errorMessage={messageFromResponseError(
        errorAgentDetails,
        'We encountered an error while fetching the details for this Agent. Please try again later.'
      )}
      hasError={isErrorAgentDetails}
      isLoading={isLoadingAgentDetails}
      isLoadingOverlayFullScreen={false}
      loadingBoxProps={{
        sx: { minHeight: '8rem' }
      }}
    >
      {activeAgent && agentDetails && (
        <AgentDetails agent={activeAgent} agentDetails={agentDetails} />
      )}
    </PageSection>
  )
}
